

import * as hexToRgba from 'hex-to-rgba/build/index'

export class DataLine {

    private static readonly LINEAR_START_TRANSPARENCY = 0.8;
    private static readonly  LINEAR_STOP_TRANSPARENCY = 0;

    protected _value : number[];
    protected _color : string;
    protected _background: boolean;

    public constructor(value: number[], color: string, background: boolean)
    {
        this._value = value;
        this._color = color;
        this._background = background;
    }

    get value(): number[] {
        return this._value;
    }

    get background(): string {
        return this._color;
    }

    get fill(): string{
        if(this._background){
            return 'start';
        }

        return 'false';
    }

    get color(): string {
        return this._color;
    }

    public calculateGradient() : [string, string]{
        if(!this._background)
            return null;

        return [hexToRgba(this.background, DataLine.LINEAR_START_TRANSPARENCY), hexToRgba(this.background, DataLine.LINEAR_STOP_TRANSPARENCY)];
    }

}



// WEBPACK FOOTER //
// ./src/app/components/charts/chart/model/base/data-line.model.ts